import { Box, Link, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import styles from "./AnnouncementBar.module.scss";
import { useTranslation } from "react-i18next";
import LinkConstants from "../../../constants/LinkConstants";

const AnnouncementBar = () => {
    const { t } = useTranslation("translation", { keyPrefix: "announcementBar" });

	return (
		<Box className={styles.anouncementBar}>
			<Typography className={styles.title}>
				{t("title")}
				<Link
					className={styles.link}
					href={LinkConstants.BRIA_API_V2}
					target="_blank"
					rel="noopener noreferrer"
				>
					{t("link")}
				</Link>
			</Typography>
		</Box>
	);
};

export default observer(AnnouncementBar);
